<template>
    <b-row>
        <b-col cols="12">
            <PageTitle title="Página no encontrada"/>
        </b-col>
        <b-col cols="12" class="text-center">
            <h1 class="p-5" style="font-size: 100px;">404</h1>
        </b-col>
    </b-row>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';

    export default {
        components: {
            PageTitle
        }
    }
</script>